// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import setRequestedDeliveryDate from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetRequestedDeliveryDate";
import setRequestedPickUpDate from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetRequestedPickUpDate";
import Button, { ButtonProps } from "@insite/mobius/Button";
import xUpdateExpressCheckout from "@rugby/App/Handlers/Checkout/UpdateExpressCheckout";
import { ExpressCheckoutCollectionModel } from "@rugby/App/Services/ExpressCheckoutService";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    xUpdateExpressCheckout,
    setRequestedDeliveryDate,
    setRequestedPickUpDate,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & ButtonProps;

const CheckoutButton: FC<Props> = ({
    xUpdateExpressCheckout,
    setRequestedDeliveryDate,
    setRequestedPickUpDate,
    children,
    onClick: onClickProps,
    ...otherProps
}) => {
    const onClickHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        xUpdateExpressCheckout({ isEnabled: true, isCalled: false } as ExpressCheckoutCollectionModel);
        setRequestedPickUpDate({ requestedPickUpDate: undefined });
        setRequestedDeliveryDate({ requestedDeliveryDate: undefined });
        onClickProps && onClickProps(event);
    };

    return (
        <Button {...otherProps} onClick={onClickHandler}>
            {children}
        </Button>
    );
};

export default connect(null, mapDispatchToProps)(CheckoutButton);
